import React, { Component } from "react";
import SidebarContainer from "./SidebarContainer";
import { Toolbar } from "primereact/toolbar";
import { withContext } from "../shared/withContext";
import { ContextIF } from "../../App";
import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { withRouter } from "react-router";
interface Props {
    context: ContextIF;
    history: any;
}
interface State {}

class Layout extends Component<Props, State> {
    state = {};

    render() {
        return (
            <div>
                <div className="wrap">
                    <div className="main">
                        <Toolbar
                            className=""
                            left={
                                <>
                                    <SidebarContainer />
                                </>
                            }
                            right={
                                <>
                                    {this.props.context.user ? (
                                        <>
                                            <div
                                                style={{
                                                    height: "2px",
                                                    fontSize: 10,
                                                }}
                                            >
                                                {/*  */}
                                            </div>
                                            <Avatar
                                                icon="pi pi-user"
                                                className="p-mr-2"
                                                shape="circle"
                                                onClick={() =>
                                                    this.props.history.push(
                                                        "/account"
                                                    )
                                                }
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <div
                                                className="p-mr-2 p-tb-2"
                                                style={{
                                                    height: "2px",
                                                    fontSize: 10,
                                                }}
                                            >
                                                {/*  <a href="https://rohdemusik.de/privacy-policy/">
                                                    Datenschutz
                                                </a> */}
                                            </div>
                                            <Button
                                                label="Login"
                                                onClick={() =>
                                                    this.props.history.push(
                                                        "/login"
                                                    )
                                                }
                                            />
                                        </>
                                    )}
                                </>
                            }
                        ></Toolbar>

                        <div id="wrapper" className="p-d-flex">
                            <div
                                id="content-wrapper"
                                className="p-d-flex p-flex-column w-100"
                            >
                                {this.props.children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(withContext(Layout));
